import { InMemoryCache } from '@apollo/client';
import { setAccessToken } from '@blocs.auth';
import { ProfileQueries } from '@minecraft.shared-queries';

export const initializeLoginState = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: ProfileQueries.IS_LOGGED_IN,
    data: {
      token: null,
      isLoggedIn: null,
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      setUserToken: (_, args, { cache }): null => {
        if (args.token !== null) {
          setAccessToken(args.token);
        }

        cache.writeQuery({
          query: ProfileQueries.IS_LOGGED_IN,
          data: {
            token: args.token,
            isLoggedIn: args.isLoggedIn,
          },
        });

        return null;
      },
    },
  },
};
